import * as _ from 'lodash';

import { useQuery as useQueryParams, useParams as useRouteParams } from '../../../../contexts/RouterContext';
import { type SnippetsRouteParams } from '../../../../hooks/api/snippets/shared';
import useSnippetPaths from '../../../../hooks/api/snippets/useSnippetPaths';
import type { SnippetsQueryParams } from '../../../../../shared/snippets';
import type { UseSnippetPathsOptions } from '../../../../hooks/api/snippets/useSnippetPaths';

/**
 * When fetching snippet root paths, we only want to consider a specific subset of query params (filters except path).
 */
const SNIPPET_ROOT_PATHS_FILTER_KEYS = [
  'ids',
  'search',
  'licenseStatus',
  'rejectionStatus',
  'packageLabels',
] as const;

/**
 * useSnippetRootPathsByUrl is a hook that fetches the root snippet paths.
 * It pulls any necessary query information from the current URL.
 */
export default function useSnippetRootPathsByUrl() {
  const routeParams = useRouteParams<SnippetsRouteParams>();
  const userRevisionLocator = `${routeParams.project_id}$${routeParams.revision_id}`;

  const [queryParams] = useQueryParams<SnippetsQueryParams>();

  const options: UseSnippetPathsOptions = {
    userRevisionLocator,
    params: _.pick(queryParams, SNIPPET_ROOT_PATHS_FILTER_KEYS),
  };

  if (queryParams.olderRevisionLocator && routeParams.status) {
    options.compare = {
      olderRevisionLocator: queryParams.olderRevisionLocator,
      status: routeParams.status,
    };
  }

  return useSnippetPaths(options);
}
